module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_3star-RGB.9fb61f1c.svg";